/**
 * @generated SignedSource<<27f050b585653cda43d608ae71af3aa3>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type variantsMerchantProductOptionsQuery$variables = {
  productID: string;
};
export type variantsMerchantProductOptionsQuery$data = {
  readonly model: {
    readonly merchantProductConnectedOptions: ReadonlyArray<{
      readonly isGlobal: boolean;
      readonly label: string;
      readonly optionID: string;
      readonly salesChannelID: number;
      readonly sku: string | null;
      readonly values: ReadonlyArray<{
        readonly label: string;
        readonly valueID: string;
      }>;
    }>;
  } | null;
};
export type variantsMerchantProductOptionsQuery = {
  response: variantsMerchantProductOptionsQuery$data;
  variables: variantsMerchantProductOptionsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "productID"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "productID"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "label",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "concreteType": "MerchantProductGraphQLOption",
  "kind": "LinkedField",
  "name": "merchantProductConnectedOptions",
  "plural": true,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "salesChannelID",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "sku",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "optionID",
      "storageKey": null
    },
    (v2/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isGlobal",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "MerchantProductGraphQLOptionValue",
      "kind": "LinkedField",
      "name": "values",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "valueID",
          "storageKey": null
        },
        (v2/*: any*/)
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "variantsMerchantProductOptionsQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Model",
        "kind": "LinkedField",
        "name": "model",
        "plural": false,
        "selections": [
          (v3/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "variantsMerchantProductOptionsQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Model",
        "kind": "LinkedField",
        "name": "model",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "ac14810e55db703bca72cb299a3e0cef",
    "id": null,
    "metadata": {},
    "name": "variantsMerchantProductOptionsQuery",
    "operationKind": "query",
    "text": "query variantsMerchantProductOptionsQuery(\n  $productID: ID!\n) {\n  model(id: $productID) {\n    merchantProductConnectedOptions {\n      salesChannelID\n      sku\n      optionID\n      label\n      isGlobal\n      values {\n        valueID\n        label\n      }\n    }\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "2131c28becc701cbe68ccc64d0279581";

export default node;
